var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroProductMediaPlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#5558ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#3c9f03",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    x2: 256,
    y1: 452,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#addcff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M377 0H135C60.557 0 0 60.557 0 135v242c0 74.443 60.557 135 135 135h242c74.443 0 135-60.557 135-135V135C512 60.557 451.443 0 377 0z",
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M377 60H135c-41.4 0-75 33.6-75 75v242c0 41.4 33.6 75 75 75h242c41.4 0 75-33.6 75-75V135c0-41.4-33.6-75-75-75zm-36.698 208.299-135.901 93.6c-4.174 3.127-10.42 3.686-15.3.901C184 360.099 181 355 181 349.6V162.4c0-5.4 2.999-10.501 8.101-13.2 4.797-2.701 10.8-2.1 15.3.899l135.901 93.6c4.197 2.701 6.599 7.5 6.599 12.301 0 4.799-2.402 9.6-6.599 12.299z",
    "data-original": "url(#b)",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroProductMediaPlayIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroProductMediaPlayIcon.b06723b8ecef0bb552a96aecfedf59ad.svg";
export { ForwardRef as ReactComponent };